export default {"src":"/_next/static/media/communities.5f84298c.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};